module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/cloud1-c8b6303df9969e312c3f2be0d52036b1.png";